/**
 * Manages the `inert` attribute on content behind modals to prevent screen readers
 * (e.g. VoiceOver) from navigating outside the modal. Inert removes elements from
 * the accessibility tree so focus stays trapped..
 */

export function applyInert(target: string): void {
  const targetEl = document.querySelector(target)
  if (!targetEl || typeof document === 'undefined') {
    return
  }

  targetEl.setAttribute('inert', '')
}

export function removeInert(target: string): void {
  const targetEl = document.querySelector(target)
  if (!targetEl || typeof document === 'undefined') {
    return
  }

  targetEl.removeAttribute('inert')
}
